import InfoPopUp from './info-pop-up';

export default InfoPopUp;